// Stubbed data for the in-house email support inbox wireframe.
// This mirrors the shape we expect the goserver backend to return so the
// frontend can be built and reviewed before the API exists. Replace the
// imports in index.jsx with real API calls once the backend lands.

export const AGENT = {
  name: 'Pankaj Soni',
  email: 'pankaj@myyogateacher.com'
};

// Left-rail primary folders. `count` is the open-conversation count shown as a pill.
export const FOLDERS = [
  { key: 'my_inbox', label: 'My Inbox', icon: 'user', count: 4 },
  { key: 'mentions', label: 'Mentions', icon: 'at', count: 1 },
  { key: 'unassigned', label: 'Unassigned', icon: 'circle', count: 3 },
  { key: 'all', label: 'All', icon: 'list', count: 13 }
];

export const TEAM_INBOXES = [
  { key: 'support', label: 'Support', emoji: '🚀', count: 9 },
  { key: 'sales', label: 'Sales', emoji: '💰', count: 2 },
  { key: 'engineering', label: 'Engineering', emoji: '😎', count: 1 },
  { key: 'escalation', label: 'Escalation', emoji: '⚠️', count: 1 },
  { key: 'tier1', label: 'Tier-1 Support', emoji: '💪', count: 0 }
];

// Agents that a conversation can be assigned to (Actions → agent picker).
export const AGENTS = [
  { key: 'demo', label: 'Demo User', initials: 'DE', you: true, online: true },
  { key: 'pankaj', label: 'Pankaj Soni', initials: 'PS', online: true },
  { key: 'ava', label: 'Ava Chen', initials: 'AC', online: false },
  { key: 'rahul', label: 'Rahul Verma', initials: 'RV', online: true },
  { key: 'mia', label: 'Mia Torres', initials: 'MT', online: false }
];

// Seed tag suggestions — the tag picker also lets you create new ones inline.
export const TAG_POOL = [
  'technical_issue',
  'billing',
  'login',
  'refund',
  'feature_request',
  'bug',
  'urgent_followup'
];

export const VIEWS = [
  { key: 'no_tags', label: 'No tags' },
  { key: 'open', label: 'Open' },
  { key: 'high_priority', label: 'High priority' }
];

// A conversation = one email thread with a customer. `messages` holds the
// timeline in chronological order. `events` are interleaved by timestamp.
export const CONVERSATIONS = [
  {
    id: 'c1',
    ticketId: 'ID-1042',
    folder: 'all',
    inbox: 'support',
    contact: {
      name: 'Yash Kadam',
      email: 'yash.kadam@myyogateacher.com',
      avatar: 'https://i.pravatar.cc/120?img=12',
      availability: 'Not available',
      integrations: []
    },
    subject: 'Cannot access my premium classes',
    preview: 'Demo User added tag technical_issue',
    channel: 'Email support',
    unread: 9,
    status: 'resolved',
    priority: 'none',
    tags: ['technical_issue'],
    lastActivity: '1y',
    assignee: 'Pankaj Soni',
    timeline: [
      {
        type: 'message',
        from: 'customer',
        author: 'Yash Kadam',
        at: '9 Feb, 09:55 PM',
        body: 'Hi team, I upgraded to premium last week but the premium classes still show as locked in the app. Can you help?'
      },
      {
        type: 'message',
        from: 'agent',
        author: 'Pankaj Soni',
        at: '9 Feb, 11:20 PM',
        body: 'Hi Yash — thanks for reaching out. I can see the upgrade on our end. Could you try logging out and back in so the entitlement refreshes?'
      },
      { type: 'divider', label: '10 Feb 2025' },
      {
        type: 'message',
        from: 'customer',
        author: 'Yash Kadam',
        at: '10 Feb, 12:02 AM',
        body: "No, that's all. Thanks!"
      },
      {
        type: 'event',
        at: '13 Feb, 9:45 PM',
        label: 'Demo User marked the conversation as Resolved'
      },
      { type: 'event', at: '18 Feb, 12:19 AM', label: 'Demo User added tag technical_issue' }
    ],
    notes: [
      {
        author: 'Demo User',
        at: '3 months ago',
        body: 'Long-time customer. Prefers concise replies and bullet points.'
      }
    ],
    attributes: [
      { label: 'Plan', value: 'Premium (annual)' },
      { label: 'Signup', value: 'Jan 2023' },
      { label: 'Lifetime value', value: '$540' }
    ],
    previous: [
      { title: 'Demo User marked the conversation as Resolved', created: '1y', updated: '1y' },
      { title: 'Refund processed (5-7 business days). Kindly check.', created: '1y', updated: '1y' }
    ]
  },
  {
    id: 'c2',
    ticketId: 'ID-1043',
    folder: 'all',
    inbox: 'support',
    contact: {
      name: 'Deepa Iyer',
      email: 'deepa.iyer@example.com',
      avatar: 'https://i.pravatar.cc/120?img=45',
      availability: 'Available',
      integrations: []
    },
    subject: 'Assigned to Support team',
    preview: 'Assigned to Support team by workflow',
    channel: 'Email support',
    unread: 5,
    status: 'open',
    priority: 'low',
    tags: [],
    lastActivity: '1y',
    assignee: null,
    timeline: [
      {
        type: 'message',
        from: 'customer',
        author: 'Deepa Iyer',
        at: '2 Feb, 04:10 PM',
        body: 'I purchased your premium plan but was charged twice on my card. Please refund the duplicate charge.'
      },
      { type: 'event', at: '2 Feb, 04:11 PM', label: 'Assigned to Support team by workflow' }
    ],
    notes: [],
    attributes: [
      { label: 'Plan', value: 'Premium (monthly)' },
      { label: 'Lifetime value', value: '$120' }
    ],
    previous: [{ title: 'Billing question about annual upgrade', created: '2y', updated: '1y' }]
  },
  {
    id: 'c3',
    ticketId: 'ID-1051',
    folder: 'all',
    inbox: 'support',
    contact: {
      name: 'Sophia Larkins',
      email: 'sophia.larkins@example.com',
      avatar: 'https://i.pravatar.cc/120?img=32',
      availability: 'Available',
      integrations: []
    },
    subject: 'Cannot login to my account',
    preview: 'Hi, I cannot login to my account...',
    channel: 'Email support',
    unread: 1,
    status: 'open',
    priority: 'high',
    tags: ['login'],
    lastActivity: '1y',
    assignee: 'Pankaj Soni',
    timeline: [
      {
        type: 'message',
        from: 'customer',
        author: 'Sophia Larkins',
        at: '5 Feb, 08:30 AM',
        body: 'Hi, I cannot login to my account. It says my password is incorrect but I just reset it. Please help.'
      }
    ],
    notes: [],
    attributes: [{ label: 'Plan', value: 'Free trial' }]
  },
  {
    id: 'c4',
    ticketId: 'ID-1067',
    folder: 'all',
    inbox: 'engineering',
    contact: {
      name: 'Felix Morin',
      email: 'felix.morin@example.com',
      avatar: 'https://i.pravatar.cc/120?img=15',
      availability: 'Not available',
      integrations: []
    },
    subject: 'Deployed software issue',
    preview: 'Hey, deployed your software and...',
    channel: 'Email support',
    unread: 8,
    status: 'open',
    priority: 'urgent',
    tags: ['FRD', 'RD'],
    lastActivity: '1y',
    assignee: null,
    timeline: [
      {
        type: 'message',
        from: 'customer',
        author: 'Felix Morin',
        at: '6 Feb, 02:15 PM',
        body: 'Hey, deployed your software and the webhook integration is throwing 500s on every callback. Logs attached.'
      }
    ],
    notes: [],
    attributes: [{ label: 'Plan', value: 'Enterprise' }]
  },
  {
    id: 'c5',
    ticketId: 'ID-1072',
    folder: 'all',
    inbox: 'sales',
    contact: {
      name: 'Vikram Shekhawat',
      email: 'vikram.s@example.com',
      avatar: 'https://i.pravatar.cc/120?img=53',
      availability: 'Available',
      integrations: []
    },
    subject: 'Payment Failed - Third Attempt',
    preview: 'Payment Failed - Third Attempt...',
    channel: 'Email support',
    unread: 1,
    status: 'open',
    priority: 'medium',
    tags: ['billing'],
    lastActivity: '1y',
    assignee: null,
    timeline: [
      {
        type: 'message',
        from: 'customer',
        author: 'Vikram Shekhawat',
        at: '7 Feb, 10:00 AM',
        body: 'My payment failed for the third time this month even though my card is valid. What is going on?'
      }
    ],
    notes: [],
    attributes: [{ label: 'Plan', value: 'Premium (monthly)' }]
  }
];
